<template>
  <section class="text-center">
    <p>Etes-vous sûr de vouloir supprimer cette saison ?</p>
<div class="">
  <button @click="onSubmit" class="ml-3 btn btn-outline-success">OUI</button>
    </div>
  </section>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
name: "Delete",
  props: {
    saison: {
      type: Object
    }
  },
  data(){
    return{}
  },
components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosDeleteData',
    ]),
    onSubmit() {
      this.axiosDeleteData({
        table: 'saisons',
        table_id: this.saison.saison_id,
      })
          .then(() => {
            location.reload(false)
          })
          .catch(() => {
          })
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/saisons/components/Delete.vue